import { VariablesToTest } from "./variablesToTest";

export const TestsElements = ({
  itemResult,
  saveDataRef,
  setBtnLoading,
  callGetCombine,
}) => {
  return (
    <div className=" border border-blue-700 rounded px-4 py-3 items-center mb-3">
      <div className="font-normal">
        <b className="text-[#5057FF]">{itemResult?.attempt}: </b>{" "}
        {itemResult?.name}
      </div>
      {itemResult?.test?.map((itemTest, indexTest) => (
        <VariablesToTest
          key={indexTest}
          itemTest={{
            ...itemTest,
            physicalTestName: itemResult?.name,
            unit: itemResult?.unit,
          }}
          saveDataRef={saveDataRef}
          setBtnLoading={setBtnLoading}
          callGetCombine={callGetCombine}
        />
      ))}
    </div>
  );
};
